import { Injectable } from '@angular/core';
import { MessageService } from '../../../@hornbillfx/components/message/message.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NotificationService {

    notificationModel: any = {
        type: 'bar',
        message: 'This notification looks so perfect!',
        color: 'info',
        position: 'top',
        current: 0
    };

    constructor(private notification: MessageService) {

    }

    public successNotification(operation, componentName) {
        const MESSAGE = `SUCCESSFULLY ${operation} IN ${componentName}`;
        const notificationModel: any = {
            type: 'bar',
            message: MESSAGE.toUpperCase(),
            color: 'info',
            position: 'top',
            current: 0
        };
        return this.creteNotification(notificationModel, 4000);
    }

    public errorNotification() {
        const notificationModel: any = {
            type: 'bar',
            message: 'Somthing went wrong',
            color: 'danger',
            position: 'top',
            current: 0
        };
        return this.creteNotification(notificationModel, 5000);
    }

    public sessionExpaireNotification() {
        const notificationModel: any = {
            type: 'bar',
            message: 'Session has been logged out,as the same user tried to login with another system',
            color: 'danger',
            position: 'top',
            current: 0
        };
        return this.creteNotification(notificationModel, 6000);
    }

    public errorMessageNotification(errorMessage) {
        const notificationModel: any = {
            type: 'bar',
            message: errorMessage,
            color: 'warning',
            position: 'top',
            current: 0
        };
        return this.creteNotification(notificationModel);
    }

    private creteNotification(notificationModel, duration?) {
        this.notification.create(
            notificationModel.color,
            notificationModel.message,
            {
                Position: notificationModel['position'],
                Style: notificationModel.type,
                Duration: duration ? duration : 2000
            });
    }

    public successNotificationForUserPanel(operation, componentName) {
        const MESSAGE = ` ${operation}  ${componentName} SUCCESSFULLY `;
        const notificationModel: any = {
            type: 'bar',
            message: MESSAGE.toUpperCase(),
            color: 'info',
            position: 'top',
            current: 0,
        };
        return this.creteNotification(notificationModel, 6000);
    }
    public creteInfoNotification(operation, componentName) {
        const MESSAGE = ` ${operation}  ${componentName} `;
        const notificationModel: any = {
            type: 'bar',
            message: MESSAGE.toUpperCase(),
            color: 'info',
            position: 'top',
            current: 0,
        };
        return this.creteNotification(notificationModel, 6000);
    }

    public creatErrorNotification(message) {
        const Message =`${message}`
        const notificationModel: any = {
            type: 'bar',
            message: Message.toUpperCase(),
            color: 'danger',
            position: 'top',
            current: 0
        };
        return this.creteNotification(notificationModel, 5000);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/service/notification.service.ts